module.exports = __webpack_public_path__ + "img/lights.a188d9e5.jpg";